export const WIKI_SECTION_CHANGE_EVENTS = {
    UPDATE: "update",
    DELETE: "delete",
    CREATE: "create",
    REORDER: "reorder",
}
